(function () {
    'use strict';
    var content = document.querySelector('.gh-content');
    if (!content || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;

    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    var images = [];

    content.querySelectorAll('.kg-image-card img, .kg-gallery-image img').forEach(function (img, index) {
        if (img.src && img.src.indexOf('.svg') === -1) {
            images.push({
                src: img.src,
                w: img.naturalWidth || img.width || 1200,
                h: img.naturalHeight || img.height || 800,
                el: img,
                index: index
            });

            img.style.cursor = 'zoom-in';
            img.addEventListener('click', function (e) {
                e.preventDefault();
                openLightbox(index);
            });
        }
    });

    function openLightbox(index) {
        var items = images.map(function (item) {
            return { src: item.src, w: item.w, h: item.h };
        });

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            index: index,
            bgOpacity: 0.95,
            showHideOpacity: true,
            history: false
        });

        gallery.init();
    }
})();
